"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var csod = require("player-core");
var JobRequisitionLocationDataProvider = (function () {
    function JobRequisitionLocationDataProvider() {
    }
    JobRequisitionLocationDataProvider.prototype.getLocationTitle = function (jobDetail) {
        var displayTitle = '';
        if (jobDetail.additionalLocations.length) {
            displayTitle = csod.locales.get("{0} Locations Available", "{0} Locations Available", jobDetail.additionalLocations.length + 1);
        }
        else {
            displayTitle = this.getLocationDisplayTitle(jobDetail.primaryLocation.city, jobDetail.primaryLocation.state, jobDetail.primaryLocation.country);
        }
        return displayTitle;
    };
    JobRequisitionLocationDataProvider.prototype.getLocationDisplayTitleForSearch = function (locations) {
        var displayTitle = "";
        if (locations.length) {
            if (locations.length > 1) {
                displayTitle = this.getLocationDisplayTitleWithCount(locations.length);
            }
            else {
                displayTitle = this.getLocationDisplayTitle(locations[0].city, locations[0].state, locations[0].country);
            }
        }
        return displayTitle;
    };
    JobRequisitionLocationDataProvider.prototype.getLocationDisplayTitleWithCount = function (count) {
        return csod.locales.get("{0} Locations Available", "{0} Locations Available", count);
    };
    JobRequisitionLocationDataProvider.prototype.getLocationDisplayTitle = function (city, state, country) {
        var displayTitle = "";
        if (!this.isStringNullOrEmpty(city)) {
            displayTitle = "" + city;
        }
        if (!this.isStringNullOrEmpty(state)) {
            if (displayTitle.length > 0) {
                displayTitle += ", " + state;
            }
            else {
                displayTitle = "" + state;
            }
        }
        if (!this.isStringNullOrEmpty(country)) {
            var countryString = csod.locales.get("Country." + country, "" + country);
            if (displayTitle.length > 0) {
                displayTitle += ", " + countryString;
            }
            else {
                displayTitle = "" + countryString;
            }
        }
        return displayTitle;
    };
    JobRequisitionLocationDataProvider.prototype.isStringNullOrEmpty = function (stringLiteral) {
        return !stringLiteral || stringLiteral.length == 0;
    };
    JobRequisitionLocationDataProvider.prototype.getLocationsWithDisplayTitle = function (jobDetail) {
        var allLocations = new Array();
        var primaryLocationDisplayTitle = this.getLocationDisplayTitle(jobDetail.primaryLocation.city, jobDetail.primaryLocation.state, jobDetail.primaryLocation.country);
        if (primaryLocationDisplayTitle.length > 0) {
            jobDetail.primaryLocation.locationDisplayTitle = primaryLocationDisplayTitle;
            allLocations.push(jobDetail.primaryLocation);
        }
        for (var _i = 0, _a = jobDetail.additionalLocations; _i < _a.length; _i++) {
            var location = _a[_i];
            var displayTitle = this.getLocationDisplayTitle(location.city, location.state, location.country);
            if (displayTitle.length == 0) {
                continue;
            }
            location.locationDisplayTitle = displayTitle;
            allLocations.push(location);
        }
        return allLocations;
    };
    return JobRequisitionLocationDataProvider;
}());
exports.JobRequisitionLocationDataProvider = JobRequisitionLocationDataProvider;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/f257358f111b2299/src/shared/JobRequisitionLocationDataProvider.ts
// module id = 97
// module chunks = 0